'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { SeoStructureData } from './modules/SeoStructureData';
interface SeoContextProps {
  seoStructuredData: any;
}
const SeoContext = createContext<SeoContextProps | undefined>(undefined);
interface SeoProviderProps {
  children: ReactNode;
  seoStructuredData: any;
}
export const SeoProvider = t0 => {
  const $ = _c(7);
  const {
    children,
    seoStructuredData
  } = t0;
  let t1;
  let t2;
  if ($[0] !== seoStructuredData) {
    t1 = {
      seoStructuredData
    };
    t2 = <SeoStructureData seoStructuredData={seoStructuredData} />;
    $[0] = seoStructuredData;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1 || $[5] !== t2) {
    t3 = <SeoContext.Provider value={t1}>{t2}{children}</SeoContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const useSeoStrucureData = () => {
  const context = useContext(SeoContext);
  if (!context) {
    throw new Error("useSeoStrucureData must be used within a SeoProvider");
  }
  return context;
};